import { Component, inject, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { ActivatedRoute } from '@angular/router';
import { RBCheck } from '@lfw/roesberg';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AppConfig } from '../../appconfig';
import { LfwRouterService } from '../../route/lfw-router.service';
import { SettingsService } from '../../shared/settings/settings.service';

@Component({
  selector: 'lfw-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.css'],
  imports: [MatButton, MatTooltip, MatIcon, TranslatePipe]
})
export class ErrorPageComponent implements OnInit {
  longVersion = '';
  errorText = '';
  backVisible = false;
  private readonly config = inject(AppConfig);
  private readonly route = inject(ActivatedRoute);
  private readonly translate = inject(TranslateService);
  private readonly routerService = inject(LfwRouterService);
  private readonly settingsService = inject(SettingsService);

  ngOnInit(): void {
    this.longVersion = 'Version ' + this.config.version();
    this.errorText = this.config.fatalError;
    const error = this.route.snapshot.paramMap.get('error');

    if (!RBCheck.isNullOrEmpty(error)) {
      this.errorText = this.translate.instant('ERROR.' + error);
      this.backVisible = true;
    }
  }

  goBack(): void {
    this.routerService.navigateBack();
  }

  showToolTip(): boolean {
    return this.settingsService.settings.viewMode.showTooltips;
  }
}
